<template>
    <header class="cl_people_header">
        <cl-page-back class="cl_people_back" icon="page_back_white" @click="goBack"></cl-page-back>

        <span v-if="isPlayer" class="more_action">
            <slot name="more"></slot>
        </span>

        <section class="header_baseInfo_wrapper">
            <div class="header_avatar">
                <cl-avatar width="148" height="148" radius="50%" :src="peopleInfo.avatar" />
                <img
                    v-if="showTrialIcon"
                    class="icon"
                    src="@/assets/images/team/round_trial.svg"
                />
            </div>

            <div class="header_baseInfo_other">
                <h2 class="header_baseInfo_title SysFontM">
                    <span v-if="peopleInfo.player_number">{{ peopleInfo.number }}&emsp;</span>
                    <span>{{ peopleInfo['name' + this.$lang2] || peopleInfo.name }}</span>
                    <!-- 国家图片 -->
                    <img
                        v-if="peopleInfo.country"
                        width="32px"
                        height="21px"
                        class="ml8"
                        :src="`${$baseUrl.countriesUrl}${peopleInfo.country}.svg`"
                    />
                    <img 
                        v-if="peopleInfo.elite" 
                        class="ml8" 
                        width="24px" 
                        height="24px" 
                        src="@i/ts/elite_tenant_star.svg"
                    />
                </h2>

                <ol class="header_baseInfo">
                    <li class="base_item">
                        <h6 class="base_item_key">{{ $t('team.出生日期') }}</h6>
                        <span class="base_item_value">{{ peopleInfo.birthday || defaultText }}</span>
                    </li>

                    <li class="base_item">
                        <h6 class="base_item_key">{{$t('team.性别')}}</h6>
                        <span class="base_item_value">{{ peopleInfo.sex ? (peopleInfo.sex == 1 ? $t('camp.男') : $t('camp.女')) : peopleInfo.gender ? (peopleInfo.gender == 1 ? $t('camp.男') : $t('camp.女')) : defaultText }}</span>
                    </li>

                    <!-- 梯队球员 -->
                    <li class="base_item" v-if="['eliteTalentPoolHeader', 'teamHeader'].includes(type)&& peopleType === 'player'">
                        <h6 class="base_item_key">{{$t('report.梯队')}}/{{$t('team.位置')}}</h6>
                        <span class="base_item_value">{{ currentPos || defaultText }}</span>
                    </li>

                    <template v-if="!(['eliteTalentPoolHeader', 'scoutHeader', 'authorizationHeader'].includes(type))">
                        <li class="base_item" v-for="(item, index) in headerData" :key="index">
                            <h6 class="base_item_key">{{ item['name' + $lang2] }}</h6>
                            <span class="base_item_value" style="max-width: 150px;">
                                <cl-overflow-tooltip parent-class-name="base_item_value">
                                    {{ item.value || defaultText }}
                                </cl-overflow-tooltip>
                            </span>
                        </li>
                    </template>
                </ol>
            </div>
        </section>

        <section>
            <slot name="otherSlot"></slot>
        </section>
        
        <section id="header_section">
            <slot name="tab"></slot>
        </section>
    </header>
</template>

<script>
/**
 * ComponentName: people header
 * Created Date:2022/5/16
 * Author: haogang·du
 * 组件说明：
 * 这个组件是梯队人员头部和评估人员头部
 * eg:
 *     <cl-people-header :people-type="peopleType" :people-info="peopleInfo" show-state-icon></cl-people-header>
 */
import showDynamicText from '@/mixins/showDynamicText.js'
export default {
    name: 'cl-people-header',
    mixins: [showDynamicText],
    props: {
        // 组件高度 默认为277px
        height: {
            type: String,
            default: '252px',
        },
        // 人员类型 球员(player) or 教练员(coach)
        peopleType: {
            type: String,
            default: 'player',
        },
        // 人员信息
        peopleInfo: {
            type: Object,
            default: () => { },
        },
        // 球员头像宽高 默认为144
        imgW: {
            type: [Number, String],
            default: 144,
        },
        // 类型来源默认为梯队头部
        type: { // teamHeader 梯队头部 eliteTalentPoolHeader authorizationHeader scoutHeader球探头部  schoolHeader校区头部
            type: String,
            default: 'teamHeader',
        },
        // 是否显示状态icon(离队、试训)
        showStateIcon: {
            type: Boolean,
            default: false,
        },
        // 进入模块
        fromModule: {
            type: String,
            default: 'team',
        },
        // 是否单独处理返回事件
        handleClick: {
            type: Boolean,
            default: false,
        },
        // 是够显示返回箭头
        showBackIcon: {
            type: Boolean,
            default: true,
        },
        // 是否是精英球员的头部
        isElite:{
            type: Boolean,
            default: false
        },
        // 是否显示草稿icon
        showDraftIcon:{
            type: Boolean,
            default: false,
        },
    },
    computed: {
        // 是否是球员
        isPlayer () {
            return this.peopleType === 'player'
        },
        // 试训icon
        showTrialIcon () {
            let boolean = this.isPlayer && this.showStateIcon && this.peopleInfo.trial == 'true' && this.$store.state.childTenantData.type === 'PRO';
            return boolean
        },
        // 当前位置
        currentPos () {
            // console.log(this.peopleInfo)
            let text = ''
            if (this.isPlayer && this.isElite) {
                // 球员
                if (!this.peopleInfo.positions || !this.peopleInfo.positions.length) return
                this.peopleInfo.positions.map((item) => {
                    if (!item.position) return
                    // text += ' ' + item['teamName' + this.$lang] + '-' +
                    // this.getValueByKeyStatic(item.position, this.playerPositionStatic)
                    // + ' /'
                    text += item['teamName' + this.$lang]
                        ? ` ${item['teamName' + this.$lang]}-${this.getValueByKeyStatic(
                            item.position,
                            this.playerPositionStatic
                        )} /`
                        : ''
                })
                let list = text.split('')
                list.pop()
                text = list.join('')
            } else if (this.isPlayer && !this.isElite) {
                text = this.getValueByKeyStatic(this.peopleInfo.position, this.playerPositionStatic)
            } else {
                // 教练员
                text = this.peopleInfo.campJob || this.peopleInfo.title
            }
            return text
        },
        handlerPosition () {
            return this.peopleInfo.competentPosition && Array.isArray(this.peopleInfo.competentPosition)
                ? this.peopleInfo?.competentPosition?.join('/').toUpperCase()
                : this.peopleInfo.competentPosition || this.defaultText
        },
    },
    data () {
        return {
            defaultText: this.$nullText, // 默认占位符
            headerData: []
        };
    },
    watch: {
        peopleInfo: {
            deep: true,
            immediate: true,
            handler(newV) {
                if (!newV.id) {
                    return;
                }
                if(this.type !== 'eliteTalentPoolHeader' && this.type !== 'authorizationHeader') {
                    this.getHeaderData()
                }
            }
        },
    },
    methods: {
        // 获取头部动态字典
        async getHeaderData() {
			const sceneParams = {
				scene: this.$utils.getFieldsScene(this.peopleType).key,
			}
			const { data } = await this.$server.getFieldsScene(sceneParams);
            // 给data中每个item加上value字段，用来显示。
            await this.handleValue2Text(data, this.peopleInfo.fields);
			this.headerData = data;
        },
        // 返回
        goBack () {
            if (this.handleClick) {
                this.$emit('handleClick')
            } else {
                this.$router.go(-1)
            }
        },
    }
}
</script>
<style lang="scss" scoped>
    .cl_people_header {
        position: relative;
        height: 212px;
        
        .cl_people_back {
            position: absolute;
            top: 20px;
            left: 16px;
        }
        .more_action {
            position: absolute;
            top: 24px;
            right: 24px;
        }

        .header_baseInfo_wrapper {
            display: flex;
            height: 158px;
            background: url('~@i/common/player_header_bg.png') no-repeat top left/cover;
            .header_avatar {
                position: relative;
                width: 148px;
                height: 148px;
                margin: 42px 0 0 40px;
                img.icon {
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    width: 42px;
                    height: 42px;
                    border-radius: 50%;
                }
            }
        }

        .header_baseInfo_other {
            margin: 38px 0 0 32px;
            overflow: hidden;
            .header_baseInfo_title {
                display: flex;
                align-items: center;
                font-size: 20px;
                color: #fff;
            }
            .header_baseInfo {
                display: flex;
                margin-top: 20px;
                width: 100%;
                overflow-x: auto;

                &::-webkit-scrollbar-thumb:horizontal {
                    background-color: #0B1C2E;
                }
                .base_item {
                    padding-right: 32px;
                    margin-right: 32px;
                    &:nth-last-of-type(1) {
                        border-right: none;
                    }
                    .base_item_key {
                        white-space: nowrap;
                        color: rgba(255, 255, 255, 0.60);
                        font-size: 14px;
                        line-height: normal;
                    }
                    .base_item_value {
                        margin-top: 8px;
                        color: #FFF;
                        font-size: 20px;
                        line-height: normal;
                        white-space: nowrap;
                        &:nth-last-of-type(1) {
                            max-width: 200px;
                        }
                    }
                }
            }
        }

        #header_section {
            display: flex;
            align-items: center;
            padding-left: 220px;
            height: 52px;
            border-bottom: 2px solid #F3F3F3;
            background: #fff;
            box-sizing: border-box;
        }
    }
</style>
